import { render, staticRenderFns } from "./UserViewApps.vue?vue&type=template&id=1b9f65cc"
import script from "./UserViewApps.vue?vue&type=script&lang=js"
export * from "./UserViewApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports